import { orchestrator } from "satcheljs";
import { onOpenHeaderPane } from "owa-app-pane-group-actions";
import getDrawerPaneId from "owa-app-pane-group-utils/lib/getDrawerPaneId";
import openHeaderPane from "./openHeaderPane";

orchestrator(onOpenHeaderPane, ({ headerPaneName, targetWindow }) => {
    openHeaderPane(getDrawerPaneId(headerPaneName), targetWindow);
});
